// extracted by mini-css-extract-plugin
module.exports = {"text-primary":"#000000","background-accent":"#f7f7f7","background":"#ffffff","light-gray":"#6f6f6f","error":"#dc3545","link":"#0071eb"};